function _capitalize(str) {
  str = str || ''

  return `${str.substring(0, 1).toUpperCase()}${str.substring(1, str.length).toLowerCase()}`
}

function capitalize(str) {
  str = str || ''

  return `${str.substring(0, 1).toUpperCase()}${str.substring(1, str.length).toLowerCase()}`
    .replace(/_/gi, ' ')
    .split(' ')
    .map((part) => _capitalize(part))
    .join(' ')
}

function camelCaseToDash(myStr) {
  return myStr.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}

export default {
  capitalize,
  camelCaseToDash,
}



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js